import client from './index'

const getData = (data) => client['api'].get(`user/kadep/all`, {params: data})
const store = (data) => client['api'].post(`user/kadep`, data)

export {
    getData,
    store
}